export const GET_CALL_FORM_LISTS = 'GET_CALL_FORM_LISTS';
export const GET_CALL_FORM_LISTS_SUCCESS = 'GET_CALL_FORM_LISTS_SUCCESS';
export const GET_CALL_FORM_LISTS_ERROR = 'GET_CALL_FORM_LISTS_ERROR';

export const SET_IS_INITIALIZED = 'SET_IS_INITIALIZED';
export const SET_IS_SUBMITTING = 'SET_IS_SUBMITTING';
export const SET_IS_SUBMIT_SUCCEEDED = 'SET_IS_SUBMIT_SUCCEEDED';

export const RESET_CALL_SETTINGS_FORM = 'RESET_CALL_SETTINGS_FORM';
